const API_BASE = '/api';

async function apiRequest(endpoint, options = {}) {
  const url = `${API_BASE}${endpoint}`;
  const config = {
    headers: { 'Content-Type': 'application/json' },
    ...options,
    body: options.body ? JSON.stringify(options.body) : undefined,
  };

  const response = await fetch(url, config);
  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.errors?.[0] || 'Something went wrong');
    error.errors = data.errors || ['An unexpected error occurred'];
    error.status = response.status;
    throw error;
  }

  return data;
}

export const appointmentAPI = {
  createNew: (formData) =>
    apiRequest('/appointments/new', { method: 'POST', body: formData }),

  reschedule: (formData) =>
    apiRequest('/appointments/reschedule', { method: 'PUT', body: formData }),

  cancel: (formData) =>
    apiRequest('/appointments/cancel', { method: 'PUT', body: formData }),

  lookup: (confirmationNumber) =>
    apiRequest(`/appointments/lookup/${encodeURIComponent(confirmationNumber)}`),
};

export const contactAPI = {
  send: (formData) =>
    apiRequest('/contact', { method: 'POST', body: formData }),

  lookup: (referenceNumber) =>
    apiRequest(`/contact/lookup/${encodeURIComponent(referenceNumber)}`),
};

export default apiRequest;
